import React from "react";
import styled from "styled-components";

import ThinButton from "./ThinButton";
import TrackTips from "./TrackTips";
import { babyblue, greenishblue } from "../theme/Colors";

import previewImage from "images/track_guides/premium_preview";

const Wrapper = styled.div``;

const StyledTips = styled(TrackTips)`
	li:last-child {
		filter: blur(3px);
	}
`;

const Preview = styled.img`
	width: 100%;
	margin-top: 10px;
`;

const Title = styled.h3`
	margin: 0;
	color: ${babyblue};
	font-size: 1.75em;
	font-weight: bold;
	text-align: center;
	text-transform: uppercase;
`;

const Info = styled.p`
	text-align: center;
	line-height: 2;
	color: ${greenishblue};
`;

const ButtonContainer = styled.div`
	display: flex;
	gap: 30px;
	padding: 0 60px;
`;

const StyledButton = styled(ThinButton)`
	flex: 1 !important;
`;

const LimitedTrackTips = (props) => (
	<Wrapper>
		<StyledTips {...props} />
		<h3 className="TGh4">Login or upgrade to unlock premium content</h3>
		<Preview src={previewImage} />
		<p className="TGp3">
			Access detailed track maps with turn-by-turn Pro-Tips that can help improve your time and safety.
		</p>
		<ButtonContainer>
			<a className="TGbtnSm" href="/users/sign_in">
				Login
			</a>
			<a className="TGbtnSm" href="/v3/quotes/start_quote">
				Upgrade
			</a>
		</ButtonContainer>
	</Wrapper>
);

export default LimitedTrackTips;
